import React from 'react';
import { Icon, Tag } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';

const BetaTag = () => {
  return (
    <Tag
      fill="soft"
      sides="roundedRect"
      density="compact"
      leadingSlot={<Icon icon="construction" />}
    >
      {getMessage('beta')}
    </Tag>
  );
};

export default BetaTag;
